var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.334,
    height: 18.334,
    viewBox: "0 0 18.334 18.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create",
    transform: "translate(3956.076 -721.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 2.817,
    height: 18.334,
    rx: 1.409,
    transform: "translate(-3948.318 721.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 2.817,
    height: 18.334,
    rx: 1.409,
    transform: "translate(-3937.743 729.623) rotate(90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/Create.e87b6ea3b40133e09be685a0e3491a51.svg";
export { ForwardRef as ReactComponent };